import React, { useEffect, useMemo, useState } from "react";
import { Col, Row } from "reactstrap";
import { useDispatch } from "react-redux";
import { CustomButton, showToaster, toasterTypes } from "../../widgets";
import { FIELD_TYPES, FieldItem } from "../../widgets/fields";
import useFieldItem from "../../widgets/fields/UseFieldItem";
import ModalComponent from "../common/Modal/modal";
import { CreateCriteriaElements } from "./FormElements";
import { setLoading } from "../../store/slices/auth";
import { getCriteria, getFormVariables, getForms, getGroups, postCreateCriteria, updateCreateCriteria } from "./apiController";
import { useLocation } from "react-router-dom";
import CriteriaEditorComponent from "./CriteriaEditor";
import { MinusCircleFilled, MinusCircleOutlined, PlusCircleFilled, PlusCircleOutlined } from "@ant-design/icons";
import { getUserProjects } from "../project/apiController";

export default function CriteriaForm(props) {
  const dispatch = useDispatch();
  const [action, setaction] = useState<any | "">("");
  const [showCodeEditor, setShowCodeEditor] = useState(false);
  const [formList, SetFormList] = useState<any>([]);
  const [destinationFormList, SetDestinationFormList] = useState<any>([]);
  const [projectList, SetProjectList] = useState<any>([]);
  const [groupData, SetGroup] = useState<any>([]);
  const [formvariables, setformVariables] = useState<any>([]);
  const [formvariablesValue, setformVariablesValue] = useState<any>([]);
  const [rules, Setrules] = useState<any>([]);
  const [isInitialized, setIsInitialized] = useState(false);
  const [pendingInterProjectData, setPendingInterProjectData] = useState<any>(null);
  const location = useLocation();


  const [values, fields, handleChange, { validateValues, updateValue, updateError, removeErrors }] =
    useFieldItem(CreateCriteriaElements, {}, { onValueChange });

  /**
   * on value change for form fields
   * @param name 
   * @param value 
   * @param values 
   * @param fieldValues 
   * @returns 
   */
  function onValueChange(name, value, values, fieldValues = null) {
    let resetValue = {};

    if (name == "criteria_type") {
      if (value.value === "intraproject") {
        resetValue = { project: "", destination: "" };
        SetDestinationFormList([...formList]);
      } else {
        resetValue = { destination: "" };
        SetDestinationFormList([]);
      }
      removeErrors("project");
      removeErrors("destination");
    }

    if (name == "project") {
      fetchInterProjectForms(value.value);
      resetValue = { destination: "" };
      removeErrors("destination");
    }

    if (name == "source") {
      fetchFormVariables(value);
    }

    // Extract the ID from the field name
    const getIdFromName = (fieldName) => {
      const match = fieldName.match(/\d+$/);
      return match ? parseInt(match[0]) : null;
    };

    if (name.startsWith("variable")) {
      let fieldId = getIdFromName(name);
      let variableData = formvariables.filter(items => items.label == value.label);

      if (variableData.length > 0) {
        let fieldArray: any = [];
        variableData[0].field_value && variableData[0].field_value.map(item => {
          fieldArray.push({ label: item, value: item })
        })
        variableData[0].fielddropDown = fieldArray;

        // Find the rule by id
        let ruleIndex = rules.findIndex(r => r.id === fieldId);

        if (ruleIndex !== -1) {
          // Update existing rule
          let updatedRules = [...rules];
          updatedRules[ruleIndex] = {
            id: fieldId,
            variable: value,
            operator: updatedRules[ruleIndex].operator || "",
            uservalue: updatedRules[ruleIndex].uservalue || "",
            logicoperator: updatedRules[ruleIndex].logicoperator || "",
            variabledata: variableData[0]
          };
          Setrules(updatedRules);
        }
      }
    } else if (name.startsWith("operator")) {
      let fieldId = getIdFromName(name);
      let ruleIndex = rules.findIndex(r => r.id === fieldId);

      if (ruleIndex !== -1) {
        let updatedRules = [...rules];
        updatedRules[ruleIndex] = {
          ...updatedRules[ruleIndex],
          operator: value
        };
        Setrules(updatedRules);
      }
    } else if (name.startsWith("uservalue")) {
      let fieldId = getIdFromName(name);
      let ruleIndex = rules.findIndex(r => r.id === fieldId);

      if (ruleIndex !== -1) {
        let updatedRules = [...rules];
        updatedRules[ruleIndex] = {
          ...updatedRules[ruleIndex],
          uservalue: value
        };
        Setrules(updatedRules);
      }
    } else if (name.startsWith("logic")) {
      let fieldId = getIdFromName(name);
      let ruleIndex = rules.findIndex(r => r.id === fieldId);

      if (ruleIndex !== -1) {
        let updatedRules = [...rules];
        updatedRules[ruleIndex] = {
          ...updatedRules[ruleIndex],
          logicoperator: value
        };
        Setrules(updatedRules);
        addRules();
      }
    }

    return [
      {
        ...values,
        ...resetValue,
        [name]: value,
      },
    ];
  }

  /** onBlur check source and destination duplication */
  const onBlurAction = (type) => {
    // Only check duplication for intraproject
    if (values && values["criteria_type"]?.value === "intraproject" && values["destination"]?.label == values["source"]?.label) {
      if (type != "source") {
        updateError("destination", { hasError: true, errorMsg: "Cannot be same as Source" });
      } else {
        updateError("source", { hasError: true, errorMsg: "Cannot be same as Destination" });
      }
    }
  }

  useEffect(() => {
    if (pendingInterProjectData && projectList.length > 0 && destinationFormList.length > 0) {
      const selectedProject = projectList.find(item => item.value == pendingInterProjectData.destination_project);
      const destinationForm = destinationFormList.find(item => item.value == pendingInterProjectData.target_form_id);

      if (selectedProject) {
        updateValue({ project: selectedProject });
      }

      if (destinationForm) {
        updateValue({ destination: destinationForm });
      }

      // Clear pending data
      setPendingInterProjectData(null);
    }
  }, [projectList, destinationFormList, pendingInterProjectData]);

  // Update the original useEffect
  useEffect(() => {
    const initializeForm = async () => {
      // Fetch projects first if editing inter-project
      if (props.selectedItem?.criteria_type === "interproject") {
        fetchProjects();
      } else {
        fetchProjects();
      }

      // Fetch forms
      fetchForms(props.groupData && props.groupData?.id);

      // Initialize for new criteria
      if (!props.selectedItem && !isInitialized) {
        updateValue({ criteria_type: CreateCriteriaElements.criteria_type.values[0] });
        addRules();
        setIsInitialized(true);
      } else if (props.selectedItem && !isInitialized) {
        setIsInitialized(true);
      }
    };

    initializeForm();
  }, []);


  useEffect(() => {

  }, [rules])


  /**
   * fetch project list
   */
  const fetchProjects = async () => {
    try {
      dispatch(setLoading(true));
      const userData: any = localStorage.getItem("coguide_user");
      let tempProjects = await getUserProjects(JSON.parse(userData).UserNumber);
      let tempArray: any = [];
      tempProjects.data.map((item, i) => {
        let Obj = {
          label: item.TopicDesc,
          value: item.TopicID,
          project_id: item.id
        }
        tempArray.push(Obj)
      })
      SetProjectList(tempArray);
      dispatch(setLoading(false));
    } catch (e: any) {
      dispatch(setLoading(false));
    }
  };

  /**
   * fetch forms for inter-project
   * @param projectId 
   */
  const fetchInterProjectForms = async (topicId) => {
    try {
      dispatch(setLoading(true));
      const groups = await getGroups(topicId);
      let tempForms = await getForms(groups.data[0].id);
      SetDestinationFormList([]);
      let tempArray: any = [];
      await tempForms.map((item, i) => {
        let Obj = {
          label: item.form_name,
          value: item.id
        }
        tempArray.push(Obj)
      })
      SetDestinationFormList(tempArray);
      dispatch(setLoading(false));
    } catch (e: any) {
      dispatch(setLoading(false));
    }
  };

  /**
   * fetch form list
   * @param index 
   * @param id 
   */
  const fetchForms = async (id) => {
    try {
      dispatch(setLoading(true));
      let tempForms = await getForms(id);
      SetFormList([]);
      let tempArray: any = [];
      await tempForms.map((item, i) => {
        let Obj = {
          label: item.form_name,
          value: item.id
        }
        tempArray.push(Obj)
      })
      SetFormList(tempArray);
      SetDestinationFormList(tempArray); // Initially set destination to same as source
      if (props.selectedItem) {
        dispatch(setLoading(true));
        await fetchPreSelectedData(tempArray);
      }
      dispatch(setLoading(false));
    } catch (e: any) {
      dispatch(setLoading(false));
    }
  };


  /**
   * get variables data
   * @param formData 
   */
  const fetchFormVariables = async (formData) => {
    try {
      dispatch(setLoading(true));
      let response = await getFormVariables(formData.value);
      setformVariables([]);
      setformVariablesValue(response.data);
      let tempArray: any = [];
      response.data.map((item, i) => {
        let Obj = {
          label: item.field_name,
          value: item.id,
          field_value: item.field_value,
          field_type: item.field_type
        }
        tempArray.push(Obj)
      })
      setformVariables(tempArray);
      dispatch(setLoading(false));
      return tempArray;

    } catch (e: any) {
      setformVariables([]);
      dispatch(setLoading(false));
    }
  }

  /**
   * fetch intial selected item data
   * create rules 
   * update values objects
   */
  const fetchPreSelectedData = async (data) => {
    let autoApplyValues = CreateCriteriaElements.autoapply.values;
    let criteriaTypeValues = CreateCriteriaElements.criteria_type.values;
    let sourceform = data && data.filter(item => item.value == props.selectedItem.source_form_id);
    let destinationform = data && data.filter(item => item.value == props.selectedItem.target_form_id);
    let autoApplyValue = autoApplyValues && autoApplyValues.filter(item => item.value == props.selectedItem.auto_response_capture);
    let criteriaTypeValue = criteriaTypeValues && criteriaTypeValues.filter(item => item.value == props.selectedItem.criteria_type);

    // Set basic values first
    updateValue({
      source: sourceform[0],
      autoapply: autoApplyValue[0],
      criteria_type: criteriaTypeValue[0] || criteriaTypeValues[0]
    })

    // For intra-project, set destination immediately
    if (props.selectedItem.criteria_type === "intraproject") {
      updateValue({ destination: destinationform[0] });
    }

    // If inter-project, fetch destination forms and store pending data
    if (props.selectedItem.criteria_type === "interproject" && props.selectedItem.destination_project) {
      // Fetch destination forms
      await fetchInterProjectForms(props.selectedItem.destination_project);

      // Store pending data to be set once projectList and destinationFormList are ready
      setPendingInterProjectData({
        destination_project: props.selectedItem.destination_project,
        target_form_id: props.selectedItem.target_form_id
      });
    }

    //trigger to get variable list for selected source form
    let tempformVariables = await fetchFormVariables(sourceform[0]);
    let fieldsArray: any = [];

    //loop criteria
    props.selectedItem.criteria && props.selectedItem.criteria.filter((itemfilter) => itemfilter.key == "field").map((item, index) => {
      let conditionsTemp = props.selectedItem.criteria.filter((itemfilter) => itemfilter.key == "condition");
      const specialCharactersRegex = /[!==%^&*(),.?":{}|<>]/g;
      let Obj: any;
      let operatorTemp: any;
      let userValueTemp: any;
      let variableTemp = tempformVariables && tempformVariables.find(itemid => itemid.value == item.field_id);

      if (!variableTemp) {
        console.warn(`Variable not found for field_id: ${item.field_id}. Skipping this rule.`);
        // Show a warning to the user
        showToaster(
          toasterTypes.WARNING,
          `Some criteria fields are no longer available in the source form. Please review and update.`
        );
        return; // Skip this rule
      }

      let fieldArray: any = [];
      variableTemp.field_value && variableTemp.field_value.map(fieldItem => {
        fieldArray.push({ label: fieldItem, value: fieldItem })
      })
      variableTemp.fielddropDown = fieldArray;

      updateValue({
        [`variable${index + 1}`]: variableTemp,
        [`logic${index + 1}`]: conditionsTemp[index] ? { label: conditionsTemp[index].value, value: conditionsTemp[index].value } : {}
      })

      if (item.value_type == "expression") {
        operatorTemp = item.value.match(specialCharactersRegex);

        if (!operatorTemp || operatorTemp.length === 0) {
          console.warn(`No operator found in expression: ${item.value}`);
          operatorTemp = ["=="];
        }

        // Split by operator
        let parts = item.value.split(operatorTemp.join(""));

        // The user value is the part that is NOT 'x'
        // It could be before or after the operator
        let userValueRaw = parts.find(part => part.trim() !== 'x' && part.trim() !== '');

        // Clean up: remove quotes and trim
        let cleanedUserValue = userValueRaw ? userValueRaw.trim().replaceAll(`'`, '').replaceAll(`"`, '') : '';

        updateValue({
          [`operator${index + 1}`]: { value: operatorTemp.join(""), label: operatorTemp.join("") },
          [`uservalue${index + 1}`]: cleanedUserValue
        })

        Obj = {
          id: index + 1,
          variable: variableTemp,
          operator: { value: operatorTemp.join(""), label: operatorTemp.join("") },
          uservalue: cleanedUserValue,
          logicoperator: conditionsTemp[index] ? { label: conditionsTemp[index].value, value: conditionsTemp[index].value } : "",
          variabledata: variableTemp
        }
      } else if (item.value_type == "string") {
        operatorTemp = item.value.match(specialCharactersRegex);

        if (!operatorTemp) {
          operatorTemp = ["=="];
        }

        if (variableTemp.field_type == "radioButton" || variableTemp.field_type == "checkBox" || variableTemp.field_type == "dropDown") {
          userValueTemp = { value: item.value.replaceAll(`'`, ''), label: item.value.replaceAll(`'`, '') }
        } else {
          userValueTemp = item.value.replaceAll(`'`, '')
        }

        updateValue({
          [`operator${index + 1}`]: { value: operatorTemp.join(""), label: operatorTemp.join("") },
          [`uservalue${index + 1}`]: userValueTemp
        })

        Obj = {
          id: index + 1,
          variable: variableTemp,
          operator: { value: "==", label: "==" },
          uservalue: userValueTemp,
          logicoperator: conditionsTemp[index] ? { label: conditionsTemp[index].value, value: conditionsTemp[index].value } : "",
          variabledata: variableTemp
        }
      } else if (item.value_type == "list") {
        let valueArray = item.value.split(',').map(v => v.trim());
        userValueTemp = valueArray.map(val => ({
          value: val,
          label: val
        }));

        updateValue({
          [`operator${index + 1}`]: { value: "==", label: "==" },
          [`uservalue${index + 1}`]: userValueTemp
        })

        Obj = {
          id: index + 1,
          variable: variableTemp,
          operator: { value: "==", label: "==" },
          uservalue: userValueTemp,
          logicoperator: conditionsTemp[index] ? { label: conditionsTemp[index].value, value: conditionsTemp[index].value } : "",
          variabledata: variableTemp
        }
      }

      if (Obj) {
        fieldsArray.push(Obj)
      }
    })

    // If no rules were created (all fields were missing), add an empty rule
    if (fieldsArray.length === 0) {
      console.warn("No valid rules found. Adding empty rule.");
      addRules();
    } else {
      Setrules(fieldsArray);
    }
  }

  /**
   * submit action
   */
  const onAdd = async () => {
    // Determine required fields based on criteria type
    let requiredFields = ["criteria_type", "source", "destination"];
    if (values.criteria_type?.value === "interproject") {
      requiredFields.push("project");
    }

    if (validateValues(requiredFields)) {
      showToaster(
        toasterTypes.ERROR,
        "Please enter the proper values in the fields highlighted in red"
      );
    } else {
      props.addData(true);
      let tempCriteriaArray: any = [];
      /**
       * arrange rules
       * create criteria array of objects with expressions and conditions
       * logical operator if not empty or length 
       */
      rules && rules.map((items, i) => {
        if (items.variable['field_type'] == "number") {
          tempCriteriaArray.push({
            "key": "field",
            "field_id": items.variable['value'],
            "condition_name": `${items.variable['label']}${items.operator['label']}${items.uservalue}`,
            "value_type": "expression",
            "value": `x ${items.operator['value']} ${items.uservalue}`
          })
          if (items.logicoperator && items.logicoperator != "" && rules.length - 1 != i) {
            tempCriteriaArray.push({
              "key": "condition",
              "value_type": "logical_operator",
              "value": `${items.logicoperator['value']}`
            })
          }
        } else if (items.variable['field_type'] == "radioButton" || items.variable['field_type'] == "dropDown" || items.variable['field_type'] == 'textBox') {
          tempCriteriaArray.push({
            "key": "field",
            "field_id": items.variable['value'],
            "condition_name": items.variable['label'],
            "value_type": "expression",
            "value": `${typeof items.uservalue == 'string' ? `'` + items.uservalue + `'` : `'` + items.uservalue.label + `'`} ${items.operator['value']} x `
          })
          if (items.logicoperator && items.logicoperator != "" && rules.length - 1 != i) {
            tempCriteriaArray.push({
              "key": "condition",
              "value_type": "logical_operator",
              "value": `${items.logicoperator['value']}`
            })
          }
        } else if (items.variable['field_type'] == "checkBox") {
          tempCriteriaArray.push({
            "key": "field",
            "field_id": items.variable['value'],
            "condition_name": items.variable['label'],
            "value_type": "list",
            "value": `${items.uservalue.map((item) => item.value)}`
          })

          if (items.logicoperator && items.logicoperator != "" && rules.length - 1 != i) {
            tempCriteriaArray.push({
              "key": "condition",
              "value_type": "logical_operator",
              "value": `${items.logicoperator['value']}`
            })
          }
        }
      })

      let reqObj: any = {
        group_id: props.groupData?.id,
        criteria_type: values.criteria_type.value,
        auto_response_capture: values.autoapply.value,
        source_form_id: values.source.value,
        target_form_id: values.destination.value,
        criteria: tempCriteriaArray
      };

      // Add topic_id based on criteria type
      if (values.criteria_type.value === "intraproject") {
        reqObj.topic_id = props.projectData?.TopicID || props.projectData?.TopicCode;
      } else {
        reqObj.topic_id = props.projectData?.TopicID || props.projectData?.TopicCode; // Source project
        reqObj.destination_project = values.project.value; // Target project
      }

      try {
        dispatch(setLoading(true));
        let response: any;
        if (props.selectedItem) {
          reqObj.id = props.selectedItem.id;
          response = await updateCreateCriteria(reqObj);
        } else {
          response = await postCreateCriteria(reqObj);
        }
        dispatch(setLoading(false));
        showToaster(toasterTypes.SUCCESS, response.message);
        props.onClose();
        props.fetchFormsData();
        props.onFormCreation();
      } catch (e: any) {
        dispatch(setLoading(false));
      }
    }
  };


  const onAction = async (type, data: any = null) => {
    switch (type) {
      case 1:
        if (data?.total_responses === 0) {
          showToaster(toasterTypes.ERROR, "No Records Found");
        } else {
          dispatch(setLoading(true));
          dispatch(setLoading(false));
          setaction(type);
        }
        break;
      case 2:
        try {
          dispatch(setLoading(true));
          dispatch(setLoading(false));
          setaction(type);
        } catch (e: any) {
          dispatch(setLoading(false));
        }
        break;
      case 3:
        setaction(type);
        break;
      default:
        setaction(type);
        break;
    }
  };

  /**
   * add rules
   */
  const addRules = () => {
    let Obj = {
      id: rules.length == 0 ? 1 : rules[rules.length - 1]["id"] + 1,
      variable: "",
      operator: "",
      uservalue: "",
      logicoperator: "",
      variabledata: ""
    }
    Setrules(prevState => [...prevState, Obj])
  }

  /**
   * remove items 
   */
  const removeRules = (itemid) => {
    let updatedArray = rules.filter(item => item.id != itemid + 1)
    Setrules(updatedArray)
  }



  return (
    <ModalComponent
      width={"90%"}
      onClose={() => props.onClose()}
      isOpen={true}
      header={<b>{props.selectedItem ? `Update Criteria` : `Create Criteria`}</b>}
      centered={true}
      customClass="criteria-modal"
      body={
        <div>
          <Row>
            <Col md={4}>
              <FieldItem
                {...CreateCriteriaElements.criteria_type}
                value={values.criteria_type}
                onChange={(...e) =>
                  handleChange(CreateCriteriaElements.criteria_type.name, ...e)
                }
                touched={fields.criteria_type && fields.criteria_type.hasError}
                error={fields.criteria_type && fields.criteria_type.errorMsg}
              />
            </Col>

            {values.criteria_type?.value === "interproject" && (
              <Col md={4}>
                <FieldItem
                  {...CreateCriteriaElements.project}
                  value={values.project}
                  values={projectList && projectList}
                  onChange={(...e) =>
                    handleChange(CreateCriteriaElements.project.name, ...e)
                  }
                  touched={fields.project && fields.project.hasError}
                  error={fields.project && fields.project.errorMsg}
                />
              </Col>
            )}

            <Col md={4}>
              <FieldItem
                {...CreateCriteriaElements.source}
                value={values.source}
                values={formList && formList}
                onChange={(...e) =>
                  handleChange(CreateCriteriaElements.source.name, ...e)
                }
                touched={fields.source && fields.source.hasError}
                error={fields.source && fields.source.errorMsg}
                onBlur={() => onBlurAction("source")}
              />
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <FieldItem
                {...CreateCriteriaElements.destination}
                value={values.destination}
                values={destinationFormList && destinationFormList}
                onChange={(...e) =>
                  handleChange(CreateCriteriaElements.destination.name, ...e)
                }
                touched={fields.destination && fields.destination.hasError}
                error={fields.destination && fields.destination.errorMsg}
                onBlur={() => onBlurAction("destination")}
              />
            </Col>

            <Col md={4}>
              <FieldItem
                {...CreateCriteriaElements.autoapply}
                value={values.autoapply}
                onChange={(...e) =>
                  handleChange(CreateCriteriaElements.autoapply.name, ...e)
                }
                touched={fields.autoapply && fields.autoapply.hasError}
                error={fields.autoapply && fields.autoapply.errorMsg}
              />
            </Col>
          </Row>

          <div className="permissions-border">
            <Row className="m-0">
              <Col className="p-0">
                <div className="permissions-text">Rules</div>
              </Col>
            </Row>
          </div>
          <div className="code-editor">
            {
              rules && rules.map((item, index) => {
                return <Row key={item.id}>
                  <Col md={3}>
                    <FieldItem
                      name={"variable" + item.id}
                      value={values["variable" + item.id]}
                      values={formvariables && formvariables}
                      type={FIELD_TYPES.DROP_DOWN}
                      label={CreateCriteriaElements.variable.label}
                      onChange={(...e) =>
                        handleChange("variable" + item.id, ...e)
                      }
                      isMandatory={true}
                      touched={fields["variable" + item.id] && fields["variable" + item.id].hasError}
                      error={fields["variable" + item.id] && fields["variable" + item.id].errorMsg}
                    />
                  </Col>

                  <Col md={3}>
                    <FieldItem
                      name={"operator" + item.id}
                      value={values["operator" + item.id]}
                      values={item.variabledata && item.variabledata.field_type == "number" ?
                        CreateCriteriaElements.operator.values :
                        CreateCriteriaElements.operatorString && CreateCriteriaElements.operatorString.values ?
                          CreateCriteriaElements.operatorString.values :
                          CreateCriteriaElements.operator.values}
                      type={FIELD_TYPES.DROP_DOWN}
                      isMandatory={true}
                      label={CreateCriteriaElements.operator.label}
                      onChange={(...e) =>
                        handleChange("operator" + item.id, ...e)
                      }
                      touched={fields["operator" + item.id] && fields["operator" + item.id].hasError}
                      error={fields["operator" + item.id] && fields["operator" + item.id].errorMsg}
                    />
                  </Col>

                  <Col md={3}>
                    <FieldItem
                      name={"uservalue" + item.id}
                      value={values["uservalue" + item.id]}
                      isMandatory={true}
                      type={item.variabledata && (item.variabledata.field_type == "radioButton" || item.variabledata.field_type == "dropDown") ?
                        FIELD_TYPES.DROP_DOWN :
                        item.variabledata && item.variabledata.field_type == "checkBox" ?
                          FIELD_TYPES.MULTI_SELECT :
                          FIELD_TYPES.TEXT}
                      values={item.variabledata && item.variabledata.fielddropDown ?
                        item.variabledata.fielddropDown :
                        []}
                      label={CreateCriteriaElements.uservalue.label}
                      onChange={(...e) =>
                        handleChange("uservalue" + item.id, ...e)
                      }
                      touched={fields["uservalue" + item.id] && fields["uservalue" + item.id].hasError}
                      error={fields["uservalue" + item.id] && fields["uservalue" + item.id].errorMsg}
                    />
                  </Col>

                  <Col md={2}>
                    <FieldItem
                      name={"logic" + item.id}
                      value={values["logic" + item.id]}
                      values={CreateCriteriaElements.logicoperator.values}
                      type={FIELD_TYPES.DROP_DOWN}
                      label={CreateCriteriaElements.logicoperator.label}
                      onChange={(...e) =>
                        handleChange("logic" + item.id, ...e)
                      }
                      touched={fields["logic" + item.id] && fields["logic" + item.id].hasError}
                      error={fields["logic" + item.id] && fields["logic" + item.id].errorMsg}
                    />
                  </Col>

                  <Col md={1}>
                    <div className="add-row">
                      {rules && rules.length == index + 1 ?
                        <>
                          <PlusCircleFilled className="add" onClick={addRules} />
                          <MinusCircleOutlined className="remove" onClick={() => removeRules(index)} />
                        </>
                        :
                        <MinusCircleOutlined className="remove" onClick={() => removeRules(index)} />
                      }
                    </div>
                  </Col>

                </Row>
              })
            }

          </div>
        </div>
      }
      footer={
        <div>
          <CustomButton
            type="primary"
            isDisabled={false}
            text={props.selectedItem ? `Update` : `Create`}
            onClick={() => onAdd()}
          ></CustomButton>
        </div>
      }
    />
  );
}